//------------------------------------------------------------------------------------

// Restricts an owner/contractor list to what the logged-in admin's department is allowed
// to see. Super admins (and admins with no department set) see everything, unchanged.
// Owners with no department set yet (e.g. existing contractors registered before this
// feature existed) remain visible to everyone, so nothing disappears until they're
// explicitly assigned a department.
const filterOwnersByDepartment = (owners) => {
	const adminRaw = localStorage.getItem('admin');
	if (!adminRaw) return owners;

	const admin = JSON.parse(adminRaw);
	if (!admin || admin.superAdmin == 1 || !admin.department) return owners;

	return owners.filter((owner) => {
		if (!owner.department) return true;
		return owner.department === admin.department;
	});
};

export default filterOwnersByDepartment;

//------------------------------------------------------------------------------------
